import { createModel } from "@rematch/core";

import type { RootModel } from '.';

// Activity filter type for user activity status on event map
export type ActivityFilterType = 'activeNow' | 'activeLastHours' | 'activeLast24Hours';

export interface EventMapStoreProps {
    filter: {
        reports: boolean,
        alerts: boolean,
        devices: boolean,
        safetyReport: boolean
    },
    // Activity status filter (radio selection - only one active at a time)
    activityFilter: ActivityFilterType
};

export const eventMapInitialState: EventMapStoreProps = {
    filter: {
        reports: false,        // OFF by default
        alerts: true,          // ON by default
        devices: true,         // ON by default (POM User)
        safetyReport: false    // OFF by default
    },
    activityFilter: 'activeNow'
};

export const eventMap = createModel<RootModel>()({
    state: eventMapInitialState,
    reducers: {
        boot: (store) => {
            store = eventMapInitialState;
        },
        setFilter: (store, f: EventMapStoreProps['filter']) => {
            store.filter = f;
        },
        toggleFilter: (store, key: keyof EventMapStoreProps['filter'], v: boolean) => {
            store.filter[key] = v;
        },
        setActivityFilter: (store, filter: ActivityFilterType) => {
            store.activityFilter = filter;
        },
    }
});